import { Box, Container, Grid, Typography, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import TopNavLogo from '../TopNav/TopNavLogo';
import { white, blackText, straightFont, secondary } from '../../Constants';

export default function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: blackText,
        py: { xs: 4, md: 5 },
        // Hide on mobile since we have bottom nav
        display: { xs: 'none', md: 'block' },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between" alignItems="flex-start">
          {/* Logo & Tagline */}
          <Grid item xs={12} md={4}>
            <TopNavLogo size="large" />
            <Typography
              sx={{
                color: alpha(white, 0.7),
                fontSize: '0.9rem',
                fontFamily: straightFont,
                mt: 2,
                lineHeight: 1.6,
              }}
            >
              No stories. Just recipes.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} md={2}>
            <Typography
              sx={{
                color: white,
                fontSize: '0.85rem',
                fontFamily: straightFont,
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                mb: 2,
              }}
            >
              Explore
            </Typography>
            <Stack spacing={1}>
              <Typography
                component={Link}
                to="/home"
                sx={{
                  color: alpha(white, 0.7),
                  fontSize: '0.9rem',
                  fontFamily: straightFont,
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': { color: secondary },
                }}
              >
                Home
              </Typography>
              <Typography
                component={Link}
                to="/recipes"
                sx={{
                  color: alpha(white, 0.7),
                  fontSize: '0.9rem',
                  fontFamily: straightFont,
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': { color: secondary },
                }}
              >
                All Recipes
              </Typography>
              <Typography
                component={Link}
                to="/myFavorites"
                sx={{
                  color: alpha(white, 0.7),
                  fontSize: '0.9rem',
                  fontFamily: straightFont,
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': { color: secondary },
                }}
              >
                My Favorites
              </Typography>
            </Stack>
          </Grid>

          {/* Copyright */}
          <Grid item xs={6} md={3} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Typography
              sx={{
                color: alpha(white, 0.7),
                fontSize: '0.9rem',
                fontFamily: straightFont,
                mt: { xs: 0, md: 4 },
              }}
            >
              &copy; {new Date().getFullYear()} Evan&apos;s Oven
            </Typography>
            <Typography
              sx={{
                color: alpha(white, 0.5),
                fontSize: '0.8rem',
                fontFamily: straightFont,
                mt: 1,
              }}
            >
              All rights reserved.
            </Typography>
          </Grid>
        </Grid>

        {/* Bottom Disclaimer */}
        <Box
          sx={{
            mt: 4,
            pt: 3,
            borderTop: `1px solid ${alpha(white, 0.1)}`,
          }}
        >
          <Typography
            sx={{
              fontSize: '0.75rem',
              color: alpha(white, 0.5),
              textAlign: 'center',
              fontFamily: straightFont,
              lineHeight: 1.6,
            }}
          >
            Cooking & Food Safety Disclaimer: Recipes are for informational purposes only. Always
            follow proper food safety guidelines and manufacturer instructions when using kitchen
            appliances. By using this site, you acknowledge the site owner is not responsible for
            any injuries, foodborne illnesses, or appliance-related issues.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
